// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__OjKBF","upload":"Small_upload__kOCzV","imageWrap":"Small_imageWrap__aE_JA","removeBtn":"Small_removeBtn__2exu2"};